module.exports = window.dnn.nodeModules.ReduxDevToolsLogMonitor;